import { createFileRoute } from '@tanstack/react-router';
import { CampaignHubPage } from '@/features/marketing';

/** Campaign hub — `/marketing/campaigns/{id}`. */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/$campaignId')({
  component: CampaignHubRoute,
});

function CampaignHubRoute() {
  const { orgId, campaignId } = Route.useParams();
  return <CampaignHubPage orgId={orgId} campaignId={campaignId} />;
}
